import React, { Component } from 'react';
import Section from '../../../../components/outline/Section';
import Table from '../../../../components/_table/Table';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import columns from '../../../point/generate/PointGenerateUserList/columns';
import Button from '../../../../components/Button';
import './PointGenerateUserList.scss';

class PointGenerateUserList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { list, pagination, selectedUserIdList, getList, onCheckUser, getExcelDownload, sortOption } = this.props;

    return (
      <div className="point-generate-user-list">
        <Section title="유저 리스트">
          <div className="point-generate-user-select-info"> 활성 유저만 선택가능합니다.</div>

          <div className="excel-button">
            <Button isRadius color="light" text="엑셀 다운로드" onClick={getExcelDownload} />
          </div>

          <Table
            list={list}
            rowKey={(record) => record.id}
            pagination={pagination}
            sortOption={sortOption}
            getList={getList}
            selectedList={selectedUserIdList}
            onCheck={(list) => onCheckUser(list)}
            rowClassName={(record) => (record.uncheckable ? 'uncheckable' : null)}
            columns={(utils) =>
              columns({
                list,
                ...utils,
              })
            }
          />
        </Section>
      </div>
    );
  }
}

export default PointGenerateUserList;
